export default __webpack_public_path__ + "assets/webgl/fire_data.713795c0.bin";